module.exports = __webpack_public_path__ + "static/media/march2025-2.a6e4a2dc.webp";